import React from 'react';

const MediaSlider = () => {
  const mediaLogos = [
    { name: 'The Times of India', style: 'font-playfair text-2xl md:text-3xl font-bold tracking-tight' },
    { name: 'Hindustan Times', style: 'font-playfair text-2xl md:text-3xl font-bold tracking-widest' },
    { name: 'News18', style: 'font-playfair text-2xl md:text-3xl font-bold italic' },
    { name: 'Knocksense', style: 'font-playfair text-xl md:text-2xl font-bold tracking-tight' },
    { name: 'Curly Tales', style: 'font-playfair text-2xl md:text-3xl font-bold italic tracking-wide' },
  ];

  // Duplicate the array for seamless infinite scroll
  const duplicatedLogos = [...mediaLogos, ...mediaLogos];

  return (
    <section className="bg-warm-taupe py-12 overflow-hidden">
      <div className="relative">
        <div className="flex w-max animate-scroll">
          {duplicatedLogos.map((logo, index) => (
            <div
              key={index}
              className="flex-shrink-0 px-8 md:px-12 lg:px-16 flex items-center justify-center min-w-[250px] md:min-w-[300px]"
            >
              <span className={`${logo.style} text-espresso whitespace-nowrap`}>
                {logo.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MediaSlider;

